import { ReactLenis, useLenis } from 'lenis/react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Members from "./pages/Members";
import Navbar from "./components/Navbar";
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  return (
    <ReactLenis root options={{ smoothWheel: true, lerp: 0.1 }}>
      <Router basename="/VivtorCraftServer">
        <div className="bg-dark text-white min-h-screen font-sans overflow-hidden">
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/members" element={<Members />} />
          </Routes>
        </div>
      </Router>
    </ReactLenis>
  );
}